import { Link } from '@inertiajs/react';
import {show} from '@/actions/App/Http/Controllers/MusicController';
import Album from '@/components/album';
import { cn } from '@/lib/utils';

export default function Albums({
    albums,
    className,
}) {
    return (
        <>
            <div className={cn('grid gap-8 grid-cols-2 sm:grid-cols-2 lg:grid-cols-3', className)}>
                {albums &&
                    albums
                        .map((album, idx) => (
                            <Link
                                key={idx}
                                href={show(album.slug)}>
                                <Album key={idx} album={album} />
                            </Link>
                        ))}
            </div>
        </>
    );
}
